import React from 'react'
import { Box, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1280,
    width: '100%',
    marginBottom: 50,
    color: '#002f3d'
  },
  homePageHeader: {
    fontSize: 28,
    fontWeight: 400,
    marginTop: 30,
    marginLeft: 10
  },
  titleItemContainer: {
    margin: '15px 10px'
  },
  titleImageContainer: {
    height: 230,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  titleTextContainer: {
    padding: '10px 20px',
    background: 'white'
  },
  titleText: {
    display: 'block',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: '32px'
  },
  subTitleText: {
    display: 'block',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 1.45
  }
}))

const TitleList = () => {
  const classes = useStyles()

  const {
    sectionTitle,
    a1LinkCampaigns,
    a1TitleCampaigns,
    a1CaptionCampaigns,
    a1PictureCampaigns,
    a2LinkCampaigns,
    a2TitleCampaigns,
    a2CaptionCampaigns,
    a2PictureCampaigns,
    a3LinkCampaigns,
    a3TitleCampaigns,
    a3CaptionCampaigns,
    a3PictureCampaigns
  } = useSelector((state) => state.language.text)

  const contents = [
    {
      imageSource: a1PictureCampaigns,
      title: a1TitleCampaigns,
      subTitle: a1CaptionCampaigns,
      link: a1LinkCampaigns
    },
    {
      imageSource: a2PictureCampaigns,
      title: a2TitleCampaigns,
      subTitle: a2CaptionCampaigns,
      link: a2LinkCampaigns
    },
    {
      imageSource: a3PictureCampaigns,
      title: a3TitleCampaigns,
      subTitle: a3CaptionCampaigns,
      link: a3LinkCampaigns
    }
  ]
  return (
    <>
      <Grid container justify="center" spacing={0}>
        <Grid item className={classes.container}>
          <Grid
            container
            alignItems="flex-start"
            justify="flex-start"
            spacing={0}>
            <Grid item xs={12} className={classes.homePageHeader}>
              {sectionTitle}
            </Grid>

            {contents.map(({ imageSource, title, subTitle, link }) => (
              <Grid key={title} item xs={12} sm={6} md={4}>
                <a href={link}>
                  <Box className={classes.titleItemContainer}>
                    <Box
                      className={classes.titleImageContainer}
                      style={{ backgroundImage: `url(${imageSource})` }}></Box>
                    <Box className={classes.titleTextContainer}>
                      <span className={classes.titleText}> {title}</span>
                      <span className={classes.subTitleText}> {subTitle}</span>
                    </Box>
                  </Box>
                </a>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default TitleList
